module.exports = {
	name: 'list',
	data() {
		return {};
	}
};


// WEBPACK FOOTER //
// ./src/components/Modules/List/List.js